<template>
  <div id="lentes" class="hw-wrap style2 bg-albastor">
    <div class="container ptb-100">
      <div class="row">
        <div class="col-xl-7 col-lg-6 order-xl-2 order-lg-2 order-md-1 order-1">
          <div class="hw-content">
            <div class="content-title style2 mb-30">
              <span>Seguridad industrial</span>
              <h2 style="font-size: 27px;">Lentes de Seguridad Graduados para Empleados en Entornos Industriales</h2>
              
            </div>
            <ul class="nav nav-tabs hw-tablist" role="tablist">
              <li class="nav-item">
                <button
                  class="tab-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_1"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-human-brain"></i> Ventajas
                </button>
              </li>
              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_2"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-cardiology"></i> Variedad
                </button>
              </li>
              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_3"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-lungs"></i> Personalización
                </button>
              </li>
              <div class="col-12 text-center hero-btn">
                <a href="/lentes-de-seguridad" class="col-6 mt-5 btn style2">Ver Catálogo</a>    
              </div>
            </ul>
          </div>
        </div>
        
        <div
          class="col-xl-5 col-lg-6 order-xl-1 order-lg-1 order-md-2 order-2"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="tab-content">
            <div class="tab-pane fade show active" id="tab_1" role="tabpanel">
              <div class="hw-tab-content hw-bg-1 bg-f">
                <div class="hw-box">
                  <h3 style="
    margin: 0 0 10px;
    line-height: 1;
    font-size: 20px;
">
                    Ventajas de nuestros lentes de seguridad:
                  </h3>
                  <ul>
                    <li>Resistencia y durabilidad certificada.</li>
                    <li>Adaptados a las necesidades visuales específicas de cada empleado.</li>
                    <li>Aceptación de seguros afiliados para mayor accesibilidad.</li>
                    
                  </ul>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="tab_2" role="tabpanel">
              <div class="hw-tab-content hw-bg-3 bg-f">
                <div class="hw-box">
                  <h3 style="
    margin: 0 0 10px;
    line-height: 1;
    font-size: 20px;
">
                    Variedad de opciones para diferentes industrias
                  </h3>
                  <p style="line-height: 1.2;">
                    Desde construcción hasta manufactura, nuestros lentes de seguridad están disponibles en una amplia gama de estilos y especificaciones técnicas, adaptándose a las exigencias de cualquier entorno laboral.
                  </p>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="tab_3" role="tabpanel">
              <div class="hw-tab-content hw-bg-4 bg-f">
                <div class="hw-box">
                  <h3 style="
    margin: 0 0 10px;
    line-height: 1;
    font-size: 20px;
">
                    Personalización de lentes para cada empresa
                  </h3>
                  <p>
                    Ofrecemos soluciones personalizadas que incluyen colores, materiales y ajustes específicos según los requerimientos de tu equipo de trabajo, destacando el compromiso con su bienestar.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurDepartment",
};
</script>